/* Session token is not domain state. Jobs, deals, proposals, me are. */
const KEY = 'nd_session';

export function readStoredToken(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { token?: unknown };
    return typeof parsed.token === 'string' && parsed.token.length > 0 ? parsed.token : null;
  } catch {
    return null;
  }
}

export function writeStoredToken(token: string): void {
  sessionStorage.setItem(KEY, JSON.stringify({ token }));
}

export function clearStoredToken(): void {
  sessionStorage.removeItem(KEY);
}

/** DEV-only: minted initData or a stored session skips the TonConnect gate
 *  so a plain browser can talk to the real API. Production is unchanged. */
export function isDevSessionBypass(): boolean {
  if (!import.meta.env.DEV || typeof window === 'undefined') return false;
  try {
    if (new URLSearchParams(window.location.search).has('initData')) return true;
    if (sessionStorage.getItem('nd_init_data')) return true;
    if (sessionStorage.getItem(KEY)) return true;
  } catch {
    /* private mode */
  }
  return false;
}
